import axios from "axios";

const API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

/**
 * queryOpenAI takes the entire conversation history (array of messages)
 * and sends it to OpenAI. The last user message is appended in ActionProvider.
 */
export async function queryOpenAI(conversationHistory) {
  try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-3.5-turbo",
        max_tokens: 600,
        temperature: 0.3,
        messages: conversationHistory // Pass the array directly
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_KEY}`
        }
      }
    );

    return response.data.choices[0].message.content;
  } catch (error) {
    console.error("OpenAI API Error:", error);
    return "Sorry, I'm having trouble getting an answer right now.";
  }
}
